// imageFetcher.js - Frontend utility to fetch images from backend (FIXED)
const API_BASE_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:5000';
/**
 * Fetch images for all slides (SKIPS chart slides automatically)
 * @param {Array} slides - Array of slide objects with extractedContent
 * @param {string} topic - Optional presentation topic
 * @returns {Promise<Array>} Array of image results
 */
export const fetchImagesForSlides = async (slides, topic = '') => {
  try {

    
    // ✅ Filter out chart slides BEFORE sending to backend
    const slidesNeedingImages = slides.map((slide, index) => {
      const hasChartData = slide.extractedContent?.chartData;
      
      if (hasChartData) {
        
        return null; // Mark as skip
      }
      
      return slide;
    });
    
    // Count how many slides actually need images
    const imageSlidesCount = slidesNeedingImages.filter(s => s !== null).length;
    const chartSlidesCount = slides.length - imageSlidesCount;
    
  
    
    const response = await fetch(`${API_BASE_URL}/api/fetch-slide-images`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        slides: slidesNeedingImages, // Send filtered array with nulls
        topic: topic
      })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
   
    
    return data.results; // Array of { slideIndex, image: { url, photographer, ... }, success }
  } catch (error) {
    
    throw error;
  }
};

/**
 * Fetch a single image for one slide (checks if it's a chart slide first)
 * @param {Object} slideContent - Slide content object (heading, bullets, etc)
 * @param {string} topic - Optional topic
 * @returns {Promise<Object>} Image data or null if chart slide
 */
export const fetchSingleImage = async (slideContent, topic = '') => {
  try {
    // ✅ Check if this is a chart slide
    if (slideContent?.chartData) {
     
      return null;
    }
    
    // ✅ Check if imageSearchTag exists
    if (!slideContent?.imageSearchTag || slideContent.imageSearchTag.trim() === '') {
     
      return null;
    }
    
   
    
    const response = await fetch(`${API_BASE_URL}/api/fetch-single-image`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        slideContent: slideContent,
        topic: topic
      })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.image; // { url, photographer, photographerUrl, ... }
  } catch (error) {
  
    throw error;
  }
};

/**
 * Search images with custom query
 * @param {string} query - Search query
 * @param {number} count - Number of images to fetch (default: 10)
 * @returns {Promise<Object>} Image data
 */
export const searchImages = async (query, count = 10) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/search-images?query=${encodeURIComponent(query)}&count=${count}`
    );

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.images;
  } catch (error) {
    
    throw error;
  }
};

/**
 * Clear image cache on backend
 */
export const clearImageCache = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/clear-image-cache`, {
      method: 'POST'
    });

    if (!response.ok) {
      throw new Error('Failed to clear cache');
    }

    const data = await response.json();
  
    return data;
  } catch (error) {
    
    throw error;
  }
};

export default {
  fetchImagesForSlides,
  fetchSingleImage,
  searchImages,
  clearImageCache
};